import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordComponent, ResetPasswordComponent, SignUpComponent, SignUpProfileComponent } from '.';
import { SharedModule } from '../shared';
import { AuthLoginFormComponent } from './auth-login-form/auth-login-form.component';
import { AuthContainer } from './containers';
import { VerificationCodeComponent } from './verification-code/verification-code.component';
import { CodeInputModule } from 'angular-code-input';
import { TranslateModule } from '@ngx-translate/core';

const  SimulationComponent = [
    ForgotPasswordComponent,
    ResetPasswordComponent,
    SignUpComponent,
    SignUpProfileComponent,
    VerificationCodeComponent
]

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
        FormsModule,
        ReactiveFormsModule,
        CodeInputModule.forRoot({
            codeLength: 6,
            isCharsCode: true,
          }),
        TranslateModule
    ],
    declarations: [ AuthLoginFormComponent, AuthContainer, ...SimulationComponent],
    exports: [CommonModule, AuthLoginFormComponent, AuthContainer, SharedModule] ,
})
export class AuthLazyModule {}
